import ActionTypes from './ActionTypes';

const getPlaylist = payload => {
  return {
    type: ActionTypes.GET_PLAYLIST,
    payload,
  };
};
const getPublicPlaylist = payload => {
  return {
    type: ActionTypes.GET_PUBLIC_PLAYLIST,
    payload,
  };
};

const getPlaylistSongs = payload => {
  return {
    type: ActionTypes.GET_PLAYLIST_SONGS,
    payload,
  };
};



export { getPlaylist, getPublicPlaylist,getPlaylistSongs };
